import * as React from 'react'
import { useMemo } from 'react'
import { MatchPairProps } from './typings'
import { EmptyCard, LeftCard } from './atoms'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { SmallLocationCard } from '@user/components/Location'
import { locationToLocationDTO } from '@user/store/entityLocations'
import { BillToMatchButton } from '../BillToMatchDrawer'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const BillToMatch: React.FC<MatchPairProps> = (props) => {
  const {
    state: { externalBillTo },
    styles,
  } = props

  const matchedLocation = useMemo(
    () =>
      !!externalBillTo ? locationToLocationDTO(externalBillTo) : undefined,
    [externalBillTo],
  )

  const matched = !!matchedLocation

  const [rightOpen, toggleRight] = useToggleBoolean()

  return (
    <Box sx={styles.matchPair}>
      <LeftCard {...props} matched={matched} />
      {!!matchedLocation ? (
        <SmallLocationCard
          {...props}
          location={matchedLocation}
          open={rightOpen}
          toggleOpen={toggleRight}
          isEditable={false}
        />
      ) : (
        <EmptyCard>
          <Typography>Match to Bill-to Location</Typography>
          <BillToMatchButton {...props} />
        </EmptyCard>
      )}
    </Box>
  )
}
BillToMatch.displayName = 'BillToMatch'
